import { DetailedDistrictReportActionTypes } from './../actions/DetailedDistrictReportActions';

const INITIAL_STATE = {
    topBulletPoints: null,
    topIndustries: null,
    topVendors: null,
    pdfDownloadStatus: null,
    selectedCongressId: null,
    downloadInProgress: false,
    allSpending: null,
    sharedLinkActive: false,
    aggregateDisplayId: 999024,
    reportConfig: null
}

const DetailedDistrictReportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case DetailedDistrictReportActionTypes.LOAD_DETAILED_DISTRICT_REPORT_CONFIG:
            return {
                ...state,
                reportConfig: action.payload
            }

        case DetailedDistrictReportActionTypes.LOAD_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS:
            return {
                ...state,
                topBulletPoints: action.payload
            }

        case DetailedDistrictReportActionTypes.LOAD_DETAILED_DISTRICT_REPORT_TOP_INDUSTRIES:
            return {
                ...state,
                topIndustries: action.payload
            }

        case DetailedDistrictReportActionTypes.LOAD_DETAILED_DISTRICT_REPORT_TOP_VENDORS:
            return {
                ...state,
                topVendors: action.payload
            }

        case DetailedDistrictReportActionTypes.CLEAR_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS:
            return {
                ...state,
                topBulletPoints: null
            }

        case DetailedDistrictReportActionTypes.LOAD_ALL_SPENDING:
            return {
                ...state,
                allSpending: action.payload
            };

        case DetailedDistrictReportActionTypes.CLEAR_ALL_SPENDING:
            return {
                ...state,
                allSpending: null
            };

        case DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_RESET:
            return {
                ...state,
                downloadInProgress: action.payload
            }

        case DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_STARTED:
            return {
                ...state,
                downloadInProgress: action.payload
            }

        case DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_SUCCESS:
            return {
                ...state,
                pdfDownloadStatus: action.payload,
                downloadInProgress: false
            }

        case DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_FAILURE:
            return {
                ...state,
                pdfDownloadStatus: action.payload,
                downloadInProgress: false
            }

        case DetailedDistrictReportActionTypes.SET_SELECTED_DISTRICT_ID:
            return {
                ...state,
                selectedCongressId: action.payload
            }
        case DetailedDistrictReportActionTypes.CLEAR_SELECTED_DISTRICT_ID:
            return {
                ...state,
                selectedCongressId: null,
                topBulletPoints: null,
                topIndustries: null,
                topVendors: null
            }

        case DetailedDistrictReportActionTypes.SHARED_LINK_ACTIVE:
            return {
                ...state,
                sharedLinkActive: action.payload
            }

        case DetailedDistrictReportActionTypes.SET_AGGREGATE_DISPLAY_ID:
            return {
                ...state,
                aggregateDisplayId: action.payload
            }

        default:
            return state
    }
}

export default DetailedDistrictReportReducer;